export default __webpack_public_path__ + "static/Dr.HSudarshan-ed522d6d09e65e0435a2e1d29bbd1998.png";